var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8499 3.79374C18.801 2.84026 17.1993 2.84024 16.1504 3.79369C16.1016 3.83805 16.0497 3.88991 15.9824 3.95724L15.9698 3.96982L6.03657 13.903L5.96302 13.9765C5.25466 14.6846 4.79718 15.1419 4.47843 15.7048C4.15967 16.2678 4.00291 16.8954 3.76019 17.8671L3.73498 17.968L3.27241 19.8183C3.20851 20.0738 3.2834 20.3442 3.46969 20.5305C3.65597 20.7168 3.92634 20.7917 4.18192 20.7278L6.03221 20.2652L6.1331 20.24C7.1048 19.9973 7.73236 19.8405 8.29534 19.5218C8.85831 19.203 9.31561 18.7455 10.0237 18.0372L10.0972 17.9636L20.0304 8.03043L20.043 8.01781C20.1103 7.95052 20.1622 7.89869 20.2065 7.8499C21.16 6.80103 21.16 5.1993 20.2066 4.15041C20.1622 4.10163 20.1104 4.04981 20.0431 3.98254L20.043 3.98247L20.0305 3.96987L20.0179 3.95732L20.0179 3.95728C19.9506 3.88995 19.8987 3.8381 19.8499 3.79374Z",
    fill: "#7A8BA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.17a121b168408e194ce2425b0ac7648c.svg";
export { ForwardRef as ReactComponent };